import { render, staticRenderFns } from "./SinglePrizeView.vue?vue&type=template&id=2777fda5&scoped=true"
import script from "./SinglePrizeView.vue?vue&type=script&lang=js"
export * from "./SinglePrizeView.vue?vue&type=script&lang=js"
import style0 from "./SinglePrizeView.vue?vue&type=style&index=0&id=2777fda5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2777fda5",
  null
  
)

export default component.exports